/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Thumbs Up down.
 */
export const ICON_THUMBS_UP_DOWN = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2683_7681)">
      <path
        d="M10.0649 5.00022H5.82488L6.48488 1.82021C6.56488 1.45021 6.44488 1.07021 6.18488 0.800215C5.74488 0.360215 5.03488 0.360215 4.60488 0.800215L0.604883 4.80022C0.214883 5.17022 0.00488281 5.68021 0.00488281 6.21022V12.0002C0.00488281 13.1002 0.904883 14.0002 2.00488 14.0002H7.92488C8.72488 14.0002 9.44488 13.5202 9.76488 12.7902L11.9049 7.79022C12.4649 6.47021 11.4949 5.00022 10.0649 5.00022ZM22.0049 10.0002H16.0849C15.2849 10.0002 14.5649 10.4802 14.2449 11.2102L12.1049 16.2102C11.5449 17.5302 12.5049 19.0002 13.9449 19.0002H18.1849L17.5249 22.1802C17.4449 22.5502 17.5649 22.9302 17.8249 23.2002C18.2649 23.6402 18.9749 23.6402 19.4049 23.2002L23.4049 19.2002C23.7849 18.8202 23.9949 18.3202 23.9949 17.7902V12.0002C24.0049 10.9002 23.1049 10.0002 22.0049 10.0002Z"
        fill="#3D3D3D"
      />
    </g>
    <defs>
      <clipPath id="clip0_2683_7681">
        <rect fill="white" height="24" width="24" />
      </clipPath>
    </defs>
  </svg>
);
